import React, { useState } from 'react';
import './EventUpdate.css';

const EventUpdate = ({ eventData, onEventUpdate }) => {
  const [event, setEvent] = useState(eventData || {});

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setEvent((prevEvent) => ({
      ...prevEvent,
      [name]: value,
    }));
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    if (event) {
      onEventUpdate(event);
      alert('Event updated successfully!');
    }
  };

  return (
    <div className="admin-panel-container">
      <h2 className="admin-panel-title">Event Update</h2>

      <form className="event-form" onSubmit={handleSubmit}>
        <div className="form-group">
          <label htmlFor="title">Event Title</label>
          <input
            type="text"
            id="title"
            name="title"
            value={event.title || ''}
            onChange={handleInputChange}
          />
        </div>

        <div className="form-group">
          <label htmlFor="date">Event Date</label>
          <input
            type="date"
            id="date"
            name="date"
            value={event.date || ''}
            onChange={handleInputChange}
          />
        </div>

        <div className="form-group">
          <label htmlFor="time">Event Time</label>
          <input
            type="time"
            id="time"
            name="time"
            value={event.time || ''}
            onChange={handleInputChange}
          />
        </div>

        <div className="form-group">
          <label htmlFor="location">Event Location</label>
          <input
            type="text"
            id="location"
            name="location"
            value={event.location || ''}
            onChange={handleInputChange}
          />
        </div>

        <div className="form-group">
          <label htmlFor="description">Event Description</label>
          <textarea
            id="description"
            name="description"
            value={event.description || ''}
            onChange={handleInputChange}
          />
        </div>

        <button type="submit" className="submit-btn">Update Event</button>
      </form>
    </div>
  );
};

export default EventUpdate;
